import { render } from "./ResolvingLimitation.vue?vue&type=template&id=034dc3f5&scoped=true&ts=true"
import script from "./ResolvingLimitation.vue?vue&type=script&lang=ts"
export * from "./ResolvingLimitation.vue?vue&type=script&lang=ts"

import "./ResolvingLimitation.vue?vue&type=style&index=0&id=034dc3f5&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034dc3f5"]])

export default __exports__